module.exports = __webpack_public_path__ + "img/swiper2.c9bcfe50.png";